'use strict';
const ReactRedux = require('react-redux');
var React = require('react');
let BaseComponent = require('../../shared/base');

var HeaderLayout = require('../../layouts/header').HeaderLayoutComponent;
var FooterLayout = require('../../layouts/footer').FooterLayoutComponent;
let BackordersTable = require('./table');

class BackordersPage extends BaseComponent {
    render() {
        return (
            <React.Fragment>
                <div className="header mod" id="header-section">
                    <HeaderLayout categories={this.props.categories} user={this.props.user}  />
                </div>
                <div className="main" id="backorders-main">            
                    <BackordersTable user={this.props.user}/>
                </div>
                <div className="footer" id="footer-section">
                    <FooterLayout panels={this.props.panels} />
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps){
    return {
        user: state.userReducer.user
    };
}

function mapDispatchToProps (dispatch){
    return {
    };
}

const BackordersLayout = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(BackordersPage)

module.exports = {
    BackordersLayout,
    BackordersPage
}